import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="19" height="19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M8.136 14.023a6.386 6.386 0 110-12.773 6.386 6.386 0 010 12.773z" stroke="#BE00FF" strokeWidth="2" strokeMiterlimit="10" /><path d="M17.25 17.734l-4.28-4.28" stroke="#BE00FF" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" /></svg>);